<script lang="ts" setup>
import { useTemplateRef } from 'vue';

interface Props {
  labelFor: string;
  name: string;
  value: boolean;
  label: string;
  disabled?: boolean;
  sizeClasses: string;
}

const props = defineProps<Props>();

const model = defineModel<boolean>({ required: true });

const labelEl = useTemplateRef('labelEl');
defineExpose({ el: labelEl });
</script>

<template>
  <label
    ref="labelEl"
    :for="props.labelFor"
    :class="[
      'relative grid place-items-center rounded-md em-px-3',
      props.sizeClasses,
      props.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
    ]"
  >
    <input
      :id="props.labelFor"
      v-model="model"
      type="radio"
      :name="props.name"
      :value="props.value"
      :disabled="props.disabled"
      :aria-label="props.label"
      class="sr-only"
    />
    <span class="[grid-area:1/1]" :class="{ invisible: model === props.value }" aria-hidden="true">
      {{ label }}
    </span>
    <span
      class="font-bold [grid-area:1/1]"
      :class="{ invisible: model !== props.value }"
      aria-hidden="true"
    >
      {{ label }}
    </span>
  </label>
</template>
